import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconDollar: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconDollar"><Path d="M12 7.25V6.19444M12 16.75V17.8056M14.5 9C14.0437 8.36899 12.9768 7.77778 12 7.77778C10.8577 7.77778 9.36111 8.26649 9.36111 9.65432C9.36111 12.6598 14.6389 11.3949 14.6389 14.2651C14.6389 15.6425 13.1603 16.2222 12 16.2222C11.0232 16.2222 9.81739 15.631 9.36111 15M21.5 12C21.5 17.2467 17.2467 21.5 12 21.5C6.75329 21.5 2.5 17.2467 2.5 12C2.5 6.75329 6.75329 2.5 12 2.5C17.2467 2.5 21.5 6.75329 21.5 12Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconDollar;
